import { render } from "./FileUpload.vue?vue&type=template&id=cef5fb4a&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=cef5fb4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef5fb4a"]])

export default __exports__